document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.js-interview-swiper');
  if (!swiperEl) return;

  const wrapper = swiperEl.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  const slides = Array.from(wrapper.children).filter((el) => el.classList.contains('swiper-slide'));

  const MIN_SLIDES = 10;

  if (slides.length > 0) {
    const multiplier = Math.ceil(MIN_SLIDES / slides.length);
    const cloneCount = slides.length * multiplier;
    for (let i = 0; i < cloneCount; i++) {
      const clone = slides[i % slides.length].cloneNode(true);
      clone.classList.add('is-cloned');
      wrapper.appendChild(clone);
    }
  }

  new Swiper('.js-interview-swiper', {
    loop: true,
    autoplay: false,
    speed: 400,

    slidesPerView: 4.3,
    spaceBetween: 8,

    navigation: {
      prevEl: '.js-interview-swiper-prev',
      nextEl: '.js-interview-swiper-next',
    },

    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 0,
      },
      1021: {
        slidesPerView: 4.3,
        spaceBetween: 8,
      },
    },
  });
});
